<template>
  <v-dialog fullscreen v-model="dialogi">
    <!-- <div class="attachment-container"> -->
      <v-flex>
        <object v-if="type === 'pdf'" class="fs" :data="dialogi" :key="ts"></object>
        <img v-if="type === 'image'" class="fs" :src="dialogi" :key="ts" />
        <video v-if="type === 'video'" class="fs" :key="ts" :src="dialogi" controls></video>
        <v-btn
          dark
          fab
          top
          right
          absolute
          class="mt-5 mr-2 zindex"
          @click="close"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-flex>
    <!-- </div> -->
  </v-dialog>
</template>

<script>
import EventBus from '@/EventBus';

export default {
  data() {
    return {
      src: '',
    };
  },
  props: {
    dialog: {
      type: String,
      required: false,
    },
  },
  created() {
    EventBus.$on('attachment', (value) => {
      this.src = value;
      this.dialog = true;
    });
  },
  computed: {
    type() {
      let ret = '';
      if (this.dialogi) {
        const url = this.dialogi.toLowerCase();
        if (url.indexOf('.jpg') !== -1 || url.indexOf('.png') !== -1 || url.indexOf('.jpeg') !== -1) {
          ret = 'image';
        } else if (url.indexOf('.pdf')) {
          ret = 'pdf';
        } else {
          ret = 'video';
        }
      }
      return ret;
    },
    ts() {
      return Date.now();
    },
    dialogi: {
      get() {
        return this.dialog;
      },
      set(/* val */) {
      },
    },
  },
  methods: {
    close() {
      this.$store.commit('currentAttachment', null);
    },
  },
};
</script>

<style scoped>
.zindex {
  z-index: 22;
}

.video-attachment {
  background-color: rgba(37,37,37,0.9);
  z-index: 22;
}

.fs {
  background-color: rgba(37,37,37,0.9);
  z-index: 22;
  width: 100vw;
  height: 100vh;
}
/*
.attachment-container {
    width: 100vw;
    height: 100vh;
    background-color:rgba(250, 250, 250, 1);
    display:inline-block;
    float:left;
    position:relative;
}
.attachment-container div {
    max-width: 100%;
    max-height:100%;
    margin: auto;
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
}
*/
</style>
